import React, { Component } from 'react';
import Helmet from 'react-helmet';
import {isMobile} from 'react-device-detect';
import Flickity from 'react-flickity-component'
import ReactCursorPosition from 'react-cursor-position';
import PostThumbnail from './PostThumbnail';
import SiteMenu from './SiteMenu';
import Modal from './Modal';
import Contact from './Contact';
import './css/Home.css';
import './css/flickty.css';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: null,
            currentSlide: props.entryPost, 
            pushHistory: true,
            menuOpen: false, 
            modalOpen: false,
            delayOpen: false 
        }; 

        this.logoClick = this.logoClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.menuClick = this.menuClick.bind(this);
        this.goToSlideFromMenu = this.goToSlideFromMenu.bind(this);
        this.updateWindowHeight = this.updateWindowHeight.bind(this);
        this.mouseOver = this.mouseOver.bind(this);
        this.findWithAttr = this.findWithAttr.bind(this);

        window.addEventListener("resize", this.updateWindowHeight);
    }


    componentDidMount() {
        this.flkty.on('select', (i) => {
            if(this.state.currentSlide !== i){  
                this.setState({ active: this.props.posts[i].fields.slug, currentSlide: i, goToNext: false});
                if(this.state.pushHistory){
                    this.props.history.push(`/${this.props.posts[i].fields.slug}`);
                }
                document.getElementById('postCategory').textContent = this.flkty.selectedElement.getAttribute('data-caption');
            }  
            if(isMobile){
                if(this.props.posts[i].fields.imageGallery !== undefined){
                    document.getElementById('cursor-title').innerHTML = this.props.posts[i].fields.title+"<span>"+this.props.posts[i].fields.imageGallery.length+"</span>";
                } else {
                    document.getElementById('cursor-title').innerHTML = this.props.posts[i].fields.title;
                }
            }
        })

        this.flkty.on('settle', (i) => { 
            if(this.state.delayOpen){
                this.setState({
                    modalOpen: true,
                    delayOpen: !this.state.delayOpen
                });
            }
        })

        this.flkty.on('staticClick', ( event, pointer, cellElement, cellIndex ) => {   
            if(cellIndex !== undefined){
                this.flkty.select(cellIndex);
                this.setState({
                    currentSlide: cellIndex,
                    pushHistory: true,
                    modalOpen: true, 
                });
            }
        })

    }
        
    componentDidUpdate(prevProps, prevState) {
        //ON BACK OR FORWARD HISROTY BUTTON CLICK
        if (prevState.active !== this.state.active) {
            window.onpopstate = (e) => {
                console.log("ON BACK OR FORWARD");
                this.flkty.select( this.findWithAttr(prevProps.posts, 'fields', 'slug', this.props.match.params.slug) );
                this.setState({ active: this.props.match.params.slug, currentSlide: this.findWithAttr(prevProps.posts, 'fields', 'slug', this.props.match.params.slug), pushHistory: false});
            }
        }
        if (this.state.menuOpen){
            document.getElementById("menu").innerHTML = "Close";
        } else {
            document.getElementById("menu").innerHTML = "Menu";
        }
    }
    //CLOSE MODAL
    logoClick(){
        if(this.state.modalOpen){
            this.setState({
                modalOpen: false 
            }); 
        }
        if(this.state.menuOpen){
            this.setState({
                menuOpen: false 
            });     
        }
    }

    //CLOSE MODAL
    closeModal(isFromPost){
        if(isFromPost){
            this.setState({
                pushHistory: true, 
                goToNext: isFromPost
            });
            this.flkty.select( this.state.currentSlide + 1 );
        } else {
            this.setState({
                modalOpen: false 
            });   
        }
    }
    //MENU ICON CLICK
    menuClick(){
        this.setState({
            menuOpen: !this.state.menuOpen, 
            pushHistory: false
        });
    }    
    //MENU SLECT GO TO NEW SLIDE
    goToSlideFromMenu(targetSlide, openModal) {
        this.flkty.select( targetSlide );
        if(openModal){
            this.setState({
                menuOpen: !this.state.menuOpen, 
                pushHistory: true,
                delayOpen: true
            });
        }
    }
    //WINDOW HEIGHT 
    updateWindowHeight() {
        this.setState({ windowHeight: window.innerHeight});
    }

    //FIND WHERE THE POST SITES IN TEH ARRAY OF POSTS I.E TITLEX IS 3 IN THE ARRAY
    findWithAttr(array, attr, second, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr][second] === value) {
                return i;
            }
        }
        return 1;
    }

    mouseOver(obj) {
        if(!isMobile){
            if(obj.fields.imageGallery !== undefined ){
                document.getElementById('cursor-title').innerHTML = obj.fields.title+"<span>"+obj.fields.imageGallery.length+"</span>";
            } else {
                document.getElementById('cursor-title').innerHTML = obj.fields.title;
            }
        }
    }

    render() {
        const HomeflickityOptions = {
                cellSelector: '.home-cell',
                draggable: true,
                // adaptiveHeight: true,
                dragThreshold: 10,
                setGallerySize: true,
                pageDots: false,
                lazyLoad: 2,
                initialIndex: this.state.currentSlide,
                wrapAround: true
        }

        return (  
            <div className={ isMobile ? "home-container mobile" : "home-container"}>
            <header>
                <Helmet title="Thomas Petherick" /> 
                <h1 className={ this.state.modalOpen || this.state.menuOpen  ? "logo pointer" : "logo"} onClick={this.logoClick}>Thomas Petherick</h1>
            </header>     
                <ReactCursorPosition className={"projects"}>
                <div className="project-inner">
                    <Flickity options={HomeflickityOptions} flickityRef={c => this.flkty = c}>
                        {this.props.posts &&
                            this.props.posts.map(function(post, i){
                            return (
                                <div className="home-cell" key={post.sys.id} data-caption={post.fields.category} onMouseOver={() => this.mouseOver(post)}>
                                    { <PostThumbnail post={post} /> }
                                </div>
                            );
                            }, this)
                        }    
                    </Flickity> 
                </div>
                <PositionLabel />
                </ReactCursorPosition>
                <div id="postCategory"></div>
                <div className={ this.state.menuOpen ? "menuTrigger open" : "menuTrigger" } onClick={this.menuClick}>
                    <span id="menu" className="menuTriggerInner">Menu</span>
                </div>
                { this.state.menuOpen ? <SiteMenu nodes={this.props.posts} gallery={this.flkty} menuClickHandler={this.goToSlideFromMenu} catMenu={this.props.catMenu}/> : null }
                { this.state.modalOpen ? <Modal {...this.props.posts[this.state.currentSlide]} nextPost={this.props.posts[this.state.currentSlide+1]} currentPost={this.state.currentSlide} totalPosts={this.props.posts.length} modalHandler={this.closeModal}/> : null }
                <Contact details={this.props.contact}/>
            </div>
        )
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowHeight);
        this.flkty.isActive = false;
    }
}

export default Home;


const PositionLabel = (props) => {
    const {
      position: {
        x = 0,
        y = 0
      } = {}
    } = props;
    return (
      <div className="cursor" style={{top:y+5, left:x+5}}>
        <div id="cursor-title"></div>
      </div>
    );
};


// WEBPACK FOOTER //
// ./src/Home.js